<div class="balance-container">
  <div class="m-4">
    <p class="text-muted mb-0">{{ 'lang.balance_description' | translate }}</p>
  </div>

  <div class="mb-4">
    @if (balanceDetails?.readings?.ph; as ph) {
      <div class="d-flex justify-content-between p-3 border-bottom">
        <!-- Left: Type -->
        <div>{{ ph.label }}</div>
        <!-- Center: Value + Status -->
        <div class="unit-value equipment-status">
          {{ ph.value }} |
          @if (getStatusIcon(ph.value)) {
            <img [src]="getStatusIcon(ph.value)" />
          }
          <span>
            {{ getStatusLabel(ph.value) | splitCamelCaseTitle }}
          </span>
        </div>
        <!-- Right: Range Link -->
        <div>
          <a class="label-range-level" (click)="openModal(scaleType.Ph)">
            {{ ph.label }} Range Level Table
          </a>
        </div>
      </div>
    }
  </div>

  @for (equipment of balanceDetails?.balanceEquipment; track equipment) {
    <div>
      @if (equipment.type === 'truSense') {
        <div class="border-style-equipment mt-4">
          <div class="equipment-name m-2">
            <img class="equipment-icon" src="assets/img/tru_sense.svg" />
            <span>{{ equipment.displayName }}</span>
          </div>
          <hr class="mt-0 mb-0 ml-2 mr-2">
          <!-- Grid Details -->
          <div class="grid-container py-2">
            <div class="grid-item m-2">
              <span class="equipment-grid">{{ 'lang.equipment_status' | translate }}</span>
              <span class="equipment-status">
                @if (equipment.status === 'Calibration Required') {
                  <img src="assets/img/redWarning.svg"
                    alt="alert">
                }
                <span class="equipment-grid-value">{{ equipment.status }}</span>
              </span>
            </div>
            <!-- PH Calibration -->
            <div class="grid-item m-2">
              <span class="equipment-grid">{{ 'lang.last_ph_calibration_date' | translate }}</span>
              <span class="equipment-status">
                @if (equipment.calibration?.lastPHCalibrationDate; as phDate) {
                  <span class="equipment-grid-value">
                    {{ phDate === 'not yet calibrated'
                    ? ('lang.not_calibrated' | translate)
                    : phDate }}
                  </span>
                  @if (phDate === 'not yet calibrated') {
                    <img src="assets/img/redWarning.svg" alt="alert">
                  }
                }
              </span>
            </div>
            <!-- ORP Calibration -->
            <div class="grid-item m-2">
              <span class="equipment-grid">{{ 'lang.last_orp_calibration_date' | translate }}</span>
              <span class="equipment-status">
                @if (equipment.calibration?.lastORPCalibrationDate; as orpDate) {
                  <span class="equipment-grid-value">
                    {{ orpDate === 'not yet calibrated'
                    ? ('lang.not_calibrated' | translate)
                    : orpDate }}
                  </span>
                  @if (orpDate === 'not yet calibrated') {
                    <img src="assets/img/redWarning.svg" alt="alert">
                  }
                }
              </span>
            </div>
          </div>
        </div>
      }
    </div>
  }
</div>